import React from 'react';
import { useTheme } from '@mui/material/styles';
import { ThemedSvgProps } from '../../types';

const PoolCueBase: React.FC<ThemedSvgProps> = ({ color, size = 60, className }) => {
  const theme = useTheme();
  const accentColor = color || theme.palette.venue.snooker;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="presentation"
      className={className}
    >
      <g transform="rotate(-45 50 50)">
        {/* Butt end (bottom) - dark wood */}
        <rect x="46" y="65" width="8" height="25" rx="2" fill="#5C3A1E" />

        {/* Accent wrap band */}
        <rect x="45" y="60" width="10" height="6" rx="1" fill={accentColor} />

        {/* Shaft (middle) - lighter wood */}
        <rect x="47" y="30" width="6" height="30" rx="1" fill="#C8A876" />

        {/* Ferrule (near tip) */}
        <rect x="47.5" y="22" width="5" height="8" rx="1" fill="#E8E0D0" />

        {/* Tip (top) - white/ivory */}
        <rect x="48" y="16" width="4" height="6" rx="2" fill="#F5F0E8" />
      </g>
    </svg>
  );
};

export const PoolCue = React.memo(PoolCueBase);
